import { getBrandName } from "../buildUtils"


export const isFlyin = (): boolean => {
    return getBrandName() === 'flyin';
}   